import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

const sports = [
  { name: "Futebol", meta: "7 × 4", emoji: "⚽" },
  { name: "Truco", meta: "12 × 6", emoji: "🃏" },
  { name: "Buraco", meta: "3200 × 1800", emoji: "🎴" },
  { name: "Poker", meta: "1st of 6", emoji: "♠" },
  { name: "FIFA", meta: "3 × 1", emoji: "🎮" },
  { name: "Bowling", meta: "1st of 4", emoji: "🎳" },
  { name: "Tennis", meta: "2 – 1 sets", emoji: "🎾" },
  { name: "Beach Tennis", meta: "2 – 0 sets", emoji: "🏖" },
  { name: "Chess", meta: "Win / Draw", emoji: "♞" },
  { name: "Running", meta: "5km · 25min", emoji: "🏃" },
  { name: "Walking", meta: "3km · 45min", emoji: "🚶" },
  { name: "+ 10 more", meta: "config by admin", emoji: "✦" },
];

export default function Sports() {
  const { t } = useLang();
  return (
    <section id="sports" className="border-b border-white/10">
      <div className="py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
            <div>
              <p className="font-mono-pw uppercase text-xs tracking-[0.3em] text-[#E6FF00] mb-5">{t.sports.overline}</p>
              <h2 className="font-anton uppercase leading-[0.9] text-5xl md:text-7xl">
                {t.sports.headA} <br /> {t.sports.headB}
              </h2>
            </div>
            <p className="font-mono-pw uppercase text-xs tracking-[0.2em] text-white/40 max-w-xs md:text-right">
              {t.sports.note}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 border-t border-l border-white/10">
            {sports.map((s, i) => (
              <motion.div
                key={s.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
                data-testid={`sport-${i}`}
                className="group border-r border-b border-white/10 p-6 md:p-8 hover:bg-[#E6FF00] transition-colors duration-300"
              >
                <div className="text-3xl md:text-4xl mb-4 grayscale group-hover:grayscale-0 transition-all">{s.emoji}</div>
                <h3 className="font-anton uppercase text-xl md:text-2xl group-hover:text-black transition-colors">{s.name}</h3>
                <p className="font-mono-pw text-[11px] tracking-[0.15em] text-white/40 group-hover:text-black/60 transition-colors mt-1">
                  {s.meta}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
